import ListFeaturePage from '@/common/components/list-route/ListFeaturePage.tsx';
import { LiftFilterBarMain } from '@/features/lifts/components/LiftFilterBar.tsx';
import LiftPagination from '@/features/lifts/components/LiftPagination.tsx';
import LiftReportSidebar from '@/features/lifts/components/LiftReportSidebar.tsx';
import { liftSortAtom } from '@/features/lifts/sorting.ts';
import { LIFT_SORT_COLUMNS } from '@pac/filter/shared/lifts';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { getColumns } from '../../features/lifts/columns.tsx';
import useLiftQueryFromAtom from '../../features/lifts/hooks/useLiftQueryFromAtom.tsx';

export const Route = createFileRoute('/big-rentz-lifts/')({
  component: RouteComponent,
});

function RouteComponent() {
  const liftsQuery = useLiftQueryFromAtom();
  const columns = useMemo(() => getColumns(), []);

  return (
    <ListFeaturePage
      analyticsSurface="lifts"
      storageKey="filter-aside:big-rentz-lifts"
      query={liftsQuery}
      columns={columns}
      FilterBar={LiftFilterBarMain}
      Pagination={LiftPagination}
      ReportSidebar={LiftReportSidebar}
      sortColumns={LIFT_SORT_COLUMNS}
      sortAtom={liftSortAtom.sortAtom}
    />
  );
}
